import { render, staticRenderFns } from "./category-importer-page.vue?vue&type=template&id=1a8f3ecd&"
import script from "./category-importer-page.vue?vue&type=script&lang=js&"
export * from "./category-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports